import { ROUTER_API } from 'app/constants/api.constant';
import JwtService from '../jwtService';

export const sendMedia = async (image: Blob) => {
  const token = JwtService.getAccessToken() || '';

  const url = `${ROUTER_API}/aws/file/loyalty`;
  const params = `?token=${token}`;
  const bodyFormData = new FormData();
  bodyFormData.append('fileb', image);
  try {
    const response = await fetch(url + params, {
      body: bodyFormData,
      method: 'POST',
    });
    if (response && response.status === 200) {
      const data: { file_key: string; url: string } = await response.json();
      return data.url;
    }
    return '';
  } catch (_error) {
    return '';
  }
};

/**
 * Same upload as sendMedia, but throws instead of returning an empty string, so
 * callers that persist the URL cannot silently store one.
 */
export const sendMediaOrThrow = async (image: Blob): Promise<string> => {
  const url = await sendMedia(image);
  if (!url) {
    throw new Error('Media upload failed');
  }
  return url;
};
